import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import * as commonActionCreators from '../../../actions/common';
import * as headerActionCreators from '../../../actions/header';
import * as productActionCreators from '../../../actions/product';
let allActionCreators = Object.assign({}, commonActionCreators, headerActionCreators, productActionCreators);

class MobileMenu extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {
			searchValue: '',
		};

    // Bind event listeners
    this.checkClick = ::this.checkClick;
	}

  componentWillMount() {
    document.addEventListener('click', this.checkClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.checkClick, false);
  }

  checkClick(evt) {

    if(window.innerWidth > 1024) {
      return;
    }

    if(evt.clientX < 100 && evt.clientY < 100) {
      return;
    }

    if(this.props.header.menuOpen === true) {
      let targetElement = evt.target;

      do {
          if (targetElement == this.menuBody) {
              return;
          }
          targetElement = targetElement.parentNode;
      } while (targetElement);

      // This is a click outside, should close
      this.props.headerToggle();
    } 
  }

  openIntercom() {
    acquireIO.max();
    this.props.headerToggle();
  }

  userNav(page) {
  	this.props.headerToggle();
    window.location.href = '/' + page;
  }

  internalNav(page) {
    this.props.headerToggle();
    this.props.commonRegisterNavChange();
    this.props.productClearFilters();
    setTimeout(() => {
      this.context.router.push('/' + page);
    }, 25);
  }

  giftGuideNav() {
    window.location.href = 'https://gifts.diamondsdirect.com';
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  getMenuClass() {
  	return this.props.header.menuOpen ? 'MobileMenu open' : 'MobileMenu';
  }

  getMenuEntryClass(submenu) {
  	return this.props.header.menuSubmenu === submenu ? 'menuEntry expanded' : 'menuEntry expandable';
  }

  openSubmenu(submenu) {
  	if(this.props.header.menuSubmenu !== submenu) {
  		this.props.headerSelectSubmenu(submenu);	
  	} else {
  		this.props.headerSelectSubmenu(null);
  	}
  }

  renderDiamonds() {
  	return <div className='diamondsSub'>
  		<div className='itemWrapper' onClick={() => this.userNav('gallery/engagement-rings?mode=diamond')}>
  			<div className='ringLabel'>Diamonds</div>
  		</div>
      <div className='itemWrapper' onClick={() => this.userNav('gallery/engagement-rings')}>
        <div className='ringLabel'>Create Your Ring</div>
      </div>
  		<div className='itemWrapper' onClick={() => this.internalNav('education/diamonds')}>
  			<div className='ringLabel'>Diamond Education</div>
  		</div>
  		<div className='itemWrapper' onClick={() => this.internalNav('education/conflict-free')}>
  			<div className='ringLabel'>Conflict Free</div>
  		</div>
  	</div>;
  }

  renderEngagementRings() {
  	return <div className='engagementSub'>
  		<div className='itemWrapper' onClick={() => this.userNav('gallery/engagement-rings?mode=setting&style=solitaire')} style={{display: 'none'}}>
  			<div className='ringImg'>
  				<LazyLoadImage src='https://ddw2.diamondsdirect.com/img/menu/engagement/solitaire.png' />
  			</div>
  			<div className='ringLabel'>Solitaire Rings</div>
  		</div>
  		<div className='itemWrapper' onClick={() => this.userNav('gallery/engagement-rings?mode=setting&style=threestone')} style={{display: 'none'}}>
  			<div className='ringImg'>
  				<LazyLoadImage src='https://ddw2.diamondsdirect.com/img/menu/engagement/threestone.png' />
  			</div>
  			<div className='ringLabel'>Three-Stone Rings</div>
  		</div>
  		<div className='itemWrapper' onClick={() => this.userNav('gallery/engagement-rings?mode=setting&style=halo')} style={{display: 'none'}}>
  			<div className='ringImg'>
  				<LazyLoadImage src='https://ddw2.diamondsdirect.com/img/menu/engagement/halo.png' />
  			</div>
  			<div className='ringLabel'>Halo Rings</div>
  		</div>
  		<div className='itemWrapper' onClick={() => this.userNav('gallery/engagement-rings?mode=setting&style=pave')} style={{display: 'none'}}>
  			<div className='ringImg'>
  				<LazyLoadImage src='https://ddw2.diamondsdirect.com/img/menu/engagement/pave.png' />
  			</div>
  			<div className='ringLabel'>Pave Rings</div>
  		</div>
  		<div className='itemWrapper' onClick={() => this.userNav('gallery/engagement-rings?mode=setting&style=channel')} style={{display: 'none'}}>
  			<div className='ringImg'>
  				<LazyLoadImage src='https://ddw2.diamondsdirect.com/img/menu/engagement/channel.png' />
  			</div>
  			<div className='ringLabel'>Channel Rings</div>
  		</div>
  		<div className='mobileSubmenuButton' onClick={() => this.userNav('gallery/engagement-rings?mode=setting')} style={{display: 'none'}}>
  			View All Engagement Rings
  		</div>


      <div className='itemWrapper' onClick={() => this.userNav('gallery/engagement-rings?mode=setting')}>
        <div className='ringLabel'>Settings</div>
      </div>
      <div className='itemWrapper' onClick={() => this.userNav('gallery/engagement-rings')}>
        <div className='ringLabel'>Create Your Ring</div>
      </div>
  	</div>;
  }

  renderWeddingBands() {
  	return <div className='weddingSub'>
  		<div className='itemWrapper' onClick={() => this.userNav('gallery/wedding-bands/womens')}>
  			<div className='ringImg'>
  				<LazyLoadImage src='https://ddw2.diamondsdirect.com/img/menu/wedding/ladiesbands.svg' />
  			</div>
  			<div className='ringLabel'>Women's Bands</div>
  		</div>
  		<div className='itemWrapper' onClick={() => this.userNav('gallery/wedding-bands/mens')}>
  			<div className='ringImg'>
  				<LazyLoadImage src='https://ddw2.diamondsdirect.com/img/menu/wedding/mensbands.svg' />
  			</div>
  			<div className='ringLabel'>Men's Bands</div>
  		</div>
  	</div>;
  }

  renderDesigners() {
  	return <div className='designersSub'>
  		<div className='itemWrapper' onClick={() => this.internalNav('designers-links')}>
  			<div className='ringLabel'>Designers</div>
  		</div>
  		<div className='itemWrapper' onClick={() => this.internalNav('designer/diamonds-direct-designs')}>
  			<div className='ringLabel'>Diamonds Direct Designs</div>
  		</div>
      <div className='itemWrapper' onClick={() => this.internalNav('custom-design/')}>
        <div className='ringLabel'>Custom Design</div>
      </div>
  	</div>;
  }

  renderFineJewelry() {
  	return <div className='fineJewelrySub'>
  		<div className='mobileMenuSectionHeader'>Classic Diamond Jewelry</div>
  		<div className={'itemWrapper firstEntry'} onClick={() => this.userNav('diamond-studs')}>
  			<div className='ringImg'>
  				<LazyLoadImage src='https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/diamond_studs.svg' />
  			</div>
  			<div className='ringLabel'>Diamond Studs</div>
  		</div>
  		<div className='itemWrapper' onClick={() => this.userNav('diamond-pendants')}>
  			<div className='ringImg'>
  				<LazyLoadImage src='https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/diamond_pendant.svg' />
  			</div>
  			<div className='ringLabel'>Diamond Pendants</div>
  		</div>
  		<div className='itemWrapper' onClick={() => this.userNav('diamond-bracelets')}>
  			<div className='ringImg'>
  				<LazyLoadImage src='https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/diamond_bracelet.svg' />
  			</div>
  			<div className='ringLabel'>Diamond Bracelets</div>
  		</div>
      <div className='itemWrapper' onClick={() => this.internalNav('diamond-necklaces')}>
        <div className='ringImg'>
          <LazyLoadImage src='https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/tennis_necklace.svg' />
        </div>
        <div className='ringLabel'>Diamond Necklaces</div>
      </div>
  		<div className='mobileMenuSectionHeader'>Fashion Jewelry</div>
      <div className='mobileMenuSectionSubHeader'>Diamond, Gemstone, and Pearl Jewelry</div>
  		<div className={'itemWrapper firstEntry'} onClick={() => this.userNav('gallery/fine-jewelry?type=ring')}>
  			<div className='ringImg'>
  				<LazyLoadImage src='https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/jewel_ring.svg' />
  			</div>
  			<div className='ringLabel'>Rings</div>
  		</div>
  		<div className='itemWrapper' onClick={() => this.userNav('gallery/fine-jewelry?type=earring')}>
  			<div className='ringImg'>
  				<LazyLoadImage src='https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/jewel_earring.svg' />
  			</div>
  			<div className='ringLabel'>Earrings</div>
  		</div>
  		<div className='itemWrapper' onClick={() => this.userNav('gallery/fine-jewelry?type=necklace')}>
  			<div className='ringImg'>
  				<LazyLoadImage src='https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/jewel_necklace.svg' />
  			</div>
  			<div className='ringLabel'>Necklaces &amp; Pendants</div>
  		</div>
  		<div className='itemWrapper' onClick={() => this.userNav('gallery/fine-jewelry?type=bracelet')}>
  			<div className='ringImg'>
  				<LazyLoadImage src='https://ddw2.diamondsdirect.com/img/menu/fine-jewelry/jewel_bracelet.svg' />
  			</div>
  			<div className='ringLabel'>Bracelets</div>
  		</div>
  	</div>;
  }

  renderEducation() {
  	return <div className='educationSub'>
  		<div className='itemWrapper' onClick={() => this.internalNav('education/diamonds')}>
  			<div className='ringLabel'>Diamond Education</div>
  		</div>
  		<div className='itemWrapper' onClick={() => this.internalNav('education/gems-and-pearls')}>
  			<div className='ringLabel'>Gemstone &amp; Pearl Education</div>
  		</div>
  		<div className='itemWrapper' onClick={() => this.internalNav('education/metals')}>
  			<div className='ringLabel'>Metals of Fine Jewelry</div>
  		</div>
  		<div className='itemWrapper' onClick={() => this.internalNav('education/styles')}>
  			<div className='ringLabel'>Ring Styles</div>
  		</div>
      <div className='itemWrapper' onClick={() => this.openNew('https://blog.diamondsdirect.com/')}>
        <div className='ringLabel'>Our Blog</div>
      </div>
  	</div>;
  }

  renderAboutUs() {
  	return <div className='aboutUsSub'>
  		<div className='itemWrapper' onClick={() => this.internalNav('about-us')}>
  			<div className='ringLabel'>Our Story</div>
  		</div>
  		<div className='itemWrapper' onClick={() => this.internalNav('our-heritage')}>
  			<div className='ringLabel'>Our Heritage</div>
  		</div>
  		<div className='itemWrapper' onClick={() => this.internalNav('our-guarantees')}>
  			<div className='ringLabel'>Warranties &amp; Guarantees</div>
  		</div>
  		<div className='itemWrapper' onClick={() => this.internalNav('our-foundation')}>
  			<div className='ringLabel'>Diamonds Direct Foundation</div>
  		</div>
  	</div>;
  }

  changeSearch(evt) {
  	this.setState({
  		searchValue: evt.target.value,
  	})
  }

  keyPressSearch(evt) {
  	if(evt.key === 'Enter') {
  		this.submitSearch();
  	}
  }

  submitSearch() {
  	if(this.state.searchValue !== '') {
  		this.userNav('diamonds-direct-search?p=init&q=' + this.state.searchValue);
  	}
  }

	render() {
		return <div className={this.getMenuClass()} ref={(menuBody) => { this.menuBody = menuBody; }}>
			<div className='closeIcon' onClick={::this.props.headerToggle}>
        <div className='closeX'>&times;</div>
      </div>
      <div className='menuWrapper'>
      	<div className='logoWrapper' onClick={() => this.internalNav('')}>
      		<LazyLoadImage src='https://ddw2.diamondsdirect.com/img/header/ddlogo.svg' />
      	</div>
      	<div className={this.getMenuEntryClass('engagement-rings')} onClick={() => this.openSubmenu('engagement-rings')}>
          <div className='mobileLabel'>Engagement Rings</div>
          <div className='mobileSubmenu'>{this.renderEngagementRings()}</div>
        </div>
        <div className={this.getMenuEntryClass('diamonds')} onClick={() => this.openSubmenu('diamonds')}>
      		<div className='mobileLabel'>Diamonds</div>
      		<div className='mobileSubmenu'>{this.renderDiamonds()}</div>
      	</div>
      	<div className={this.getMenuEntryClass('wedding-bands')} onClick={() => this.openSubmenu('wedding-bands')}>
      		<div className='mobileLabel'>Wedding Bands</div>
      		<div className='mobileSubmenu'>{this.renderWeddingBands()}</div>
      	</div>
        <div className={this.getMenuEntryClass('fine-jewelry')} onClick={() => this.openSubmenu('fine-jewelry')}>
          <div className='mobileLabel'>Fine Jewelry</div>
          <div className='mobileSubmenu'>{this.renderFineJewelry()}</div>
        </div>
        <div className='menuEntry' onClick={() => this.internalNav('gallery/mens-jewelry')}>
          <div className='mobileLabel'>Men's Jewelry</div>
        </div>
        <div className='menuEntry' onClick={() => this.openNew('https://diamondsdirecttimepieces.com/')}>
          <div className='mobileLabel'>Watches</div>
        </div>
        <div className={this.getMenuEntryClass('education')} onClick={() => this.openSubmenu('education')}>
          <div className='mobileLabel'>Education</div>
          <div className='mobileSubmenu'>{this.renderEducation()}</div>
        </div>
      	<div className={this.getMenuEntryClass('designers')} onClick={() => this.openSubmenu('designers')}>
      		<div className='mobileLabel'>Designers</div>
      		<div className='mobileSubmenu'>{this.renderDesigners()}</div>
      	</div>
      	<div className={this.getMenuEntryClass('about-us')} onClick={() => this.openSubmenu('about-us')}>
      		<div className='mobileLabel'>Our Difference</div>
      		<div className='mobileSubmenu'>{this.renderAboutUs()}</div>
      	</div>
        <div className='menuEntry' onClick={() => this.internalNav('frequently-asked-questions')}>
          <div className='mobileLabel'>FAQs</div>
        </div>
        <div className='menuEntry' onClick={() => this.internalNav('financing')}>
      		<div className='mobileLabel'>Financing</div>
      	</div>
        <div className='menuEntry' onClick={() => this.internalNav('locations')}>
          <div className='mobileLabel'>Store Locations</div>
        </div>
      	<div className='menuEntry' onClick={() => this.internalNav('contact-us')}>
      		<div className='mobileLabel'>Book Appointment</div>
      	</div>

      	<div className='menuSearch' style={{ display: 'none' }}>
      		<input type='text' onChange={::this.changeSearch} onKeyPress={::this.keyPressSearch} placeholder='Search' />
      		<div className='searchButton' onClick={::this.submitSearch}>
      			<i className="fas fa-search"></i>
      		</div>
      	</div>
      	
        <div className='ggWrapper' style={{display: 'none'}}>
          <div className='ggLink' onClick={::this.giftGuideNav}></div>
        </div>

      	<div className={'menuButton'} onClick={::this.openIntercom}>Let's Chat</div>
      </div>
		</div>;
	}

}
export default MobileMenu;

function mapStateToProps(state) {
  return {
  	header: state.header
  };
}

export const MobileMenuContainer = connect(
  mapStateToProps,
  allActionCreators
)(MobileMenu);


// WEBPACK FOOTER //
// ./src/components/views/menu/MobileMenu.jsx